import { PhoneNumber as MyleModelsCommonResponsePhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { PhoneNumber } from "@/Common/Models/Contacts/PhoneNumber";
import { Patient } from "@/Common/Models/Patient/Patient";
import { Gender } from "@/Common/Models/Patient/PatientEnums";
import { WorkSafeBcAddressModel } from "./WorkSafeBcAddressModel";

class WorkSafeBcWorkerModel {
    public BirthDate: Date;
    public LastName: string;
    public FirstName: string;
    public MailingAddress: WorkSafeBcAddressModel;
    public PhoneNumber: string;
    public PhoneNumberContactPointId: string;
    public HealthCardNumber: string;
    public Gender: "M" | "F" | null;

    public constructor(init?: Partial<WorkSafeBcWorkerModel>) {
        Object.assign(this, init);
        this.MailingAddress = new WorkSafeBcAddressModel(init?.MailingAddress);
    }

    public static fromPatient(patient: Patient): WorkSafeBcWorkerModel {
        const healthCard = patient?.HealthCards?.firstOrDefault(p =>
            p.IsHealthCard
            && p.ProvinceLookupId === cacheStore.FindLookupByLookupCode("CanadaState_BC").LookupID
        );
        const phoneNumber = this.getPrimaryPhoneNumber(patient?.Phones);

        return new WorkSafeBcWorkerModel({
            BirthDate: patient?.IndividualResponse.DateOfBirth,
            LastName: patient?.IndividualResponse?.LastName?.trim() ?? "",
            FirstName: patient?.IndividualResponse?.FirstName?.trim() ?? "",
            MailingAddress: WorkSafeBcAddressModel.fromPatient(patient),
            HealthCardNumber: healthCard?.Number ?? "",
            PhoneNumber: phoneNumber?.format("+{0} ({1}) {2} {3}") ?? "",
            PhoneNumberContactPointId: phoneNumber?.Model?.ContactPoint_id,
            Gender:
                patient.Gender() === Gender.Female ? "F"
                    : patient.Gender() === Gender.Male ? "M"
                        : null
        });
    }

    private static getPrimaryPhoneNumber(phones: MyleModelsCommonResponsePhoneNumber[]): PhoneNumber {
        return new PhoneNumber(
            MyleModelsCommonResponsePhoneNumber.GetPrimaryPhoneNumber(phones)
        );
    }
}

export { WorkSafeBcWorkerModel };
